import "../../index41.css";
import { jsxs as N, jsx as V } from "react/jsx-runtime";
import { useLayoutEffect as A, useRef as D } from "react";
import { _ as u } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import x from "../../hooks/useSpacingToken.js";
import { getSpacingValue as O, fullSpacings as j, gapSpacings as z } from "../../utils/style.js";
const E = "_list-view_1yqgh_1", G = "_grid-layout_1yqgh_5", $ = "_grid-content_1yqgh_12", T = "_with-sidebar_1yqgh_15", H = "_sidebar-position-start_1yqgh_32", I = "_inline-layout_1yqgh_39", J = "_with-wrap_1yqgh_44", K = "_with-space-between-contents_1yqgh_49", M = "_with-centered-contents_1yqgh_53", Q = "_with-start-alignment_1yqgh_57", U = "_block-layout_1yqgh_62", X = "_with-full-width_1yqgh_71", Y = "_with-background_1yqgh_75", Z = "_with-dark-background_1yqgh_80", t = {
  listView: E,
  gridLayout: G,
  gridContent: $,
  withSidebar: T,
  sidebarPositionStart: H,
  inlineLayout: I,
  withWrap: J,
  withSpaceBetweenContents: K,
  withCenteredContents: M,
  withStartAlignment: Q,
  blockLayout: U,
  withFullWidth: X,
  withBackground: Y,
  withDarkBackground: Z
};
function tt(e) {
  const r = D(null);
  return e && typeof e != "function" ? e : r;
}
function ct(e) {
  const {
    className: r,
    layout: i = "inline",
    withWrap: _,
    withSpaceBetweenContents: p,
    withCenteredContents: m,
    withStartAlignment: y,
    spacing: o,
    withPadding: s,
    withBackground: f,
    withDarkBackground: S,
    children: c,
    numPreferredGridColumns: a = 2,
    minGridColumnSize: l = "12rem",
    gridContentClassName: k,
    withSidebar: C,
    sidebarPosition: b = "end",
    spacingOffset: q,
    withFullWidth: P,
    elementRef: B,
    withSpacingOpticalCorrection: L = !1,
    ...W
  } = e, n = tt(B);
  A(() => {
    var h, g, w;
    if (i === "grid") {
      (h = n.current) == null || h.style.setProperty(
        "--num-preferred-grid-columns",
        String(a)
      ), (g = n.current) == null || g.style.setProperty(
        "--min-grid-column-size",
        String(l)
      );
      const v = s ? 2 : 0, F = a - 1, R = v + F;
      (w = n.current) == null || w.style.setProperty(
        "--reserved-space",
        `calc(${O(o)} * ${R})`
      );
    }
  }, [a, l, i, s, o, n]);
  const d = x({
    spacing: o,
    offset: q,
    modes: s ? j : z,
    withoutOpticalCorrection: !L
  });
  return /* @__PURE__ */ N(
    "div",
    {
      ...W,
      ref: n,
      className: u(
        t.listView,
        i === "inline" && t.inlineLayout,
        i === "block" && t.blockLayout,
        i === "grid" && t.gridLayout,
        i !== "grid" && d,
        _ && t.withWrap,
        y && t.withStartAlignment,
        p && t.withSpaceBetweenContents,
        m && t.withCenteredContents,
        P && t.withFullWidth,
        f && t.withBackground,
        S && t.withDarkBackground,
        r
      ),
      role: i !== "grid" ? "list" : void 0,
      children: [
        i === "grid" && /* @__PURE__ */ V(
          "div",
          {
            className: u(
              t.gridContent,
              d,
              k,
              C && t.withSidebar,
              b === "start" && t.sidebarPositionStart
            ),
            role: "grid",
            children: c
          }
        ),
        i !== "grid" && c
      ]
    }
  );
}
export {
  ct as default
};
